import { LANGUAGES } from '@boltenergy-be/shared'
import { BiLingualValue } from 'types/types.ts'

export const DATE_FORMAT = 'DD/MM/YYYY'
export const DATE_FORMAT_LONG = 'D MMMM YYYY'
export const MONTH_PICKER_FORMAT = 'YYYY-MM'

export const ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss'
export const ISO8601_DATE_FORMAT = 'YYYY-MM-DD'

export const LANGUAGE_STORAGE_KEY = 'language'
export const LAST_OPENED_CONTRACT_STORAGE_KEY_PREFIX = 'last_opened_contract_'

export const PARTNER_IDS = {
  PRODUCTION_BOLT_SUPER_USER: '0010900001mIpTAAA0',
  STAGING_BOLT_SUPER_USER: '0011q00001CH6FEAA1'
}

export const BOLT_PHONE_CONTACT = '02 899 33 00'
export const BOLT_EMAIL_CONTACT = {
  [LANGUAGES.NL]: 'hallo@boltenergie.be',
  [LANGUAGES.FR]: 'bonjour@boltenergie.be'
}

export const TAKEOVER_DOCUMENT_URL: BiLingualValue<string> = {
  [LANGUAGES.NL]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/energieovernamedocument.pdf',
  [LANGUAGES.FR]: 'https://cdn.prod.backend.boltenergie.be/pdf/bolt/document-de-reprise-des-energies.pdf'
}

export const DEFAULT_FILE_SIZE_LIMIT = 3 * 1024 * 1024
